/**
 * @file Footer.ts
 * @description
 * -----------------------------------------------------
 * Archivo que contiene el componente de Footer
 * -----------------------------------------------------
 * @version 1.0.0a
 * @created 2024-12-19
 * @modified 2025-07-30
 * @author Correcta
 * @copyright © Correcta
 * @license Private
 * */
"use client";

import Link from "next/link";
import { useTranslations } from "use-intl";
import ImageComponent from "@/components/ui/ImageComponent";

const Footer = () => {
  const year = new Date().getFullYear();
  const t = useTranslations("Footer");
  const ariaLabelT = useTranslations("AriaLabel");
  return (
    <footer className={"footer"}>
      <section className="footer__iso">
        <ImageComponent
          src={"/assets/img/footerMobile.png"}
          srcDark={"/assets/img/footerMobileDark.png"}
          alt={"collaboratorsUE"}
          className={"footer__imageMobile"}
          width={800}
          height={60}
          zoomable={false}
          priority
        />
        <ImageComponent
          src={"/assets/svg/footer.svg"}
          srcDark={"/assets/svg/footer__dark.svg"}
          alt={"collaboratorsSpain"}
          className={"footer__image"}
          width={800}
          height={60}
          zoomable={false}
          priority
        />
        <ImageComponent
          src={"/assets/svg/ISO9001-light.svg"}
          srcDark={"/assets/svg/ISO9001.svg"}
          className={"footer__isoIcon"}
          alt={"EQA9001certificate"}
          width={40}
          zoomable={false}
          height={50}
          priority
        />
        <ImageComponent
          src={"/assets/svg/ISO27001-light.svg"}
          srcDark={"/assets/svg/ISO27001.svg"}
          alt={"EQA27001certificate"}
          className={"footer__isoIcon"}
          width={40}
          zoomable={false}
          height={50}
          priority
        />
        <ImageComponent
          src={"/assets/svg/ENS.svg"}
          alt={"ENScertificate"}
          className={"footer__isoIcon"}
          width={40}
          zoomable={false}
          height={50}
          priority
        />
      </section>
      <ul className="footer__links">
        <li className="footer__links-item">
          <Link
            href="https://correcta.es/contacto"
            className="footer__link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={ariaLabelT("contactLink")}
          >
            {t("contact")}
          </Link>
        </li>
        <li className="footer__links-item">
          <Link
            href="https://correcta.es/politica-de-cookies"
            className="footer__link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={ariaLabelT("cookiesLink")}
          >
            {t("cookies")}
          </Link>
        </li>
        <li className="footer__links-item">
          <Link
            href="https://correcta.es/aviso-legal"
            className="footer__link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={ariaLabelT("legalLink")}
          >
            {t("legal-notice")}
          </Link>
        </li>
        <li className="footer__links-item">
          <Link
            href="https://correcta.es/politica-de-privacidad"
            className="footer__link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={ariaLabelT("privacyLink")}
          >
            {t("privacy")}
          </Link>
        </li>
        <li className="footer__links-item">
          <Link
            href="https://correcta.es/informacion_legal"
            className="footer__link"
            target="_blank"
            rel="noopener noreferrer"
            aria-label={ariaLabelT("legal-infoLink")}
          >
            {t("legal-info")}
          </Link>
        </li>
      </ul>
      <p className={"footer__text"}>
        <ImageComponent
          src={"/assets/svg/symbol.svg"}
          srcDark="/assets/svg/symbol-negative.svg"
          alt={"logoCorrecta"}
          zoomable={false}
          width={8}
          height={8}
        />{" "}
        {year} - CORRECTA
      </p>
    </footer>
  );
};

export default Footer;
